import {
  Component,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  OnInit,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';



@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.scss']
})
export class EmailTemplateComponent implements OnInit {
  constructor(
    private httpSv: HttpService,
    private toastr: ToastrService
  ) { }

  title = 'Email Template';

  ngOnInit(): void {
    this.getTemplate();
  }

  showEditor: boolean = false;
  noTemplate: number = 0
  templateList: any[] = []
  displayedColumns: string[] = [
    "id",
    "name",
    "action",
  ];

  searchText: string = "";

  dataSource: MatTableDataSource<[]> = new MatTableDataSource(
    this.templateList
  );

  emailData: any = null
  

  filter() {
    if (this.searchText == "") {
      this.dataSource = new MatTableDataSource(this.templateList);
    } else {
      let temp = this.templateList.filter((ele: any) => {
        return ele.template_name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase()) || 
          ele.id
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase());
      });
      this.dataSource = new MatTableDataSource(temp);

      if (temp.length === 0) {
        let temp = this.templateList.filter((ele: any) => {
          return ele.unique_id
            .toLocaleLowerCase()
            .match(this.searchText.toLocaleLowerCase());
        });
        this.dataSource = new MatTableDataSource(temp);
      }
    }
  }

  showEmailEditor(data: any) {
    this.title = 'Email Template' + ' - ' + data.template_name;
    this.emailData = data;
    this.showEditor = true;
  }
  closeEditor() {
    this.title = 'Email Template';
    this.showEditor = false;
    this.emailData = null
  }
  refresh() {
    this.closeEditor();
    this.getTemplate();
  }

  getTemplate() {
    this.httpSv.getTemplate().subscribe((res: any) => {
      if (res.status == 'TRUE') {
        this.templateList = res.result.data;
        this.dataSource = new MatTableDataSource(this.templateList);
        this.filter();
      }
      else {
        this.templateList = [];
        this.dataSource = new MatTableDataSource(this.templateList);
        this.filter();
        this.toastr.error(res.message, '', { timeOut: 2000 });
      }
    }, (error: any) => {
      if (error.status == 401 || error.status == 500) {
        this.httpSv.logout();
      }
      else {
        this.templateList = [];
        this.dataSource = new MatTableDataSource(this.templateList);
        this.filter();
        this.toastr.error('Something went wrong', '', { timeOut: 2000 });
      }
    })
  }
}

@Component({
  selector: 'app-email-template-editor',
  templateUrl: './email-editor.html',
  styleUrls: ['./email-editor.scss']
})
export class EmailTemplateEditorComponent implements OnInit, AfterViewInit {
  @ViewChild('editor', { static: false }) editor!: ElementRef;
  @Input() emailData: any = null;
  @Output() onSubmit = new EventEmitter<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private httpSv: HttpService,
    private toastr: ToastrService
  ) { }

  template_id: any = null
  attachQRCode: boolean = false

  templateData = {
    subject: 'This is a demo subject',
    content: `
      <p>Hello,</p>
      <p>This is a demo email template.</p>
    `,
    buttonText: 'Demo Text',
    buttonBgColor: '#54ac58',
    buttonTextColor: '#ffffff',
    buttonBorderColor: '#54ac58',
    buttonBorderRadius: '5',
    buttonPaddingY: '12',
    buttonPaddingX: '24',
    buttonAlign: 'center',
    buttonCTA: 'link_menu_upload'
  };

  previewHtml: SafeHtml = '';
  insertBtnFlag = true;

  ngOnInit(): void {
    if (!this.emailData) return;

    const buttonSettings = this.parseButtonSettings(this.emailData.button_settings);

    this.templateData.subject = this.emailData.subject || this.templateData.subject;
    this.templateData.content = this.extractEditableContent(this.emailData.html_content || '');

    this.templateData.buttonText = buttonSettings.text || this.templateData.buttonText;
    this.templateData.buttonBgColor = buttonSettings.bg_color || this.templateData.buttonBgColor;
    this.templateData.buttonTextColor = buttonSettings.text_color || this.templateData.buttonTextColor;
    this.templateData.buttonBorderColor = buttonSettings.border_color || this.templateData.buttonBorderColor;
    this.templateData.buttonBorderRadius = String(
      buttonSettings.border_radius ?? this.templateData.buttonBorderRadius
    );
    this.templateData.buttonPaddingY = String(
      buttonSettings.padding_y ?? this.templateData.buttonPaddingY
    );
    this.templateData.buttonPaddingX = String(
      buttonSettings.padding_x ?? this.templateData.buttonPaddingX
    );
    this.templateData.buttonAlign = buttonSettings.align || this.templateData.buttonAlign;
    this.templateData.buttonCTA = buttonSettings.btn_cta || this.templateData.buttonCTA;

    this.template_id = this.emailData.id
    this.attachQRCode = this.emailData.is_qr_attached == 1 ? true : false
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.editor?.nativeElement) {
        this.editor.nativeElement.innerHTML = this.templateData.content;
      }

      this.generatePreview();
      this.cdr.detectChanges();
    });
  }

  onEditorKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Backspace') return;

    const selection = window.getSelection();
    if (!selection || !selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    if (!range.collapsed) return;

    let anchorNode = selection.anchorNode;
    const anchorOffset = selection.anchorOffset;

    if (!anchorNode) return;

    let nodeToCheck: Node | null = null;

    if (anchorNode.nodeType === Node.TEXT_NODE) {
      if (anchorOffset > 0) return;

      nodeToCheck = anchorNode.previousSibling;

      if (!nodeToCheck && anchorNode.parentNode) {
        nodeToCheck = anchorNode.parentNode.previousSibling;
      }
    } else {
      const el = anchorNode as Element;

      if (anchorOffset > 0) {
        nodeToCheck = el.childNodes[anchorOffset - 1];
      } else {
        nodeToCheck = el.previousSibling;
      }
    }

    if (
      nodeToCheck &&
      nodeToCheck.nodeType === Node.ELEMENT_NODE &&
      (nodeToCheck as HTMLElement).tagName === 'P'
    ) {
      const prev = nodeToCheck.previousSibling;
      if (prev) nodeToCheck = prev;
    }

    while (
      nodeToCheck &&
      nodeToCheck.nodeType === Node.TEXT_NODE &&
      !(nodeToCheck.textContent || '').replace(/\u00A0/g, '').trim()
    ) {
      nodeToCheck = nodeToCheck.previousSibling;
    }

    if (
      nodeToCheck &&
      nodeToCheck.nodeType === Node.ELEMENT_NODE &&
      (nodeToCheck as HTMLElement).classList.contains('fb-button-token')
    ) {
      event.preventDefault();

      if (nodeToCheck.parentNode) {
        nodeToCheck.parentNode.removeChild(nodeToCheck);
      }

      this.syncContent();
    }
  }

  exec(command: string, value: string | null = null): void {
    this.focusEditor();
    document.execCommand(command, false, value);
    this.syncContent();
  }

  setFontSize(size: string): void {
    this.focusEditor();
    document.execCommand('fontSize', false, '7');

    const editorEl = this.editor.nativeElement as HTMLElement;
    const fonts = editorEl.getElementsByTagName('font');

    for (let i = 0; i < fonts.length; i++) {
      if (fonts[i].size === '7') {
        fonts[i].removeAttribute('size');
        (fonts[i] as HTMLElement).style.fontSize = `${size}px`;
      }
    }

    this.syncContent();
  }

  setTextColor(color: string): void {
    this.focusEditor();
    document.execCommand('foreColor', false, color);
    this.syncContent();
  }

  alignText(alignment: 'left' | 'center' | 'right'): void {
    this.focusEditor();

    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    let node: any = selection.anchorNode;
    if (!node) return;

    if (node.nodeType === 3) {
      node = node.parentNode;
    }

    let block = this.findEditableBlock(node);

    if (!block) {
      document.execCommand('formatBlock', false, 'p');

      node = selection.anchorNode;
      if (node && node.nodeType === 3) {
        node = node.parentNode;
      }

      block = this.findEditableBlock(node);
    }

    if (block) {
      block.style.textAlign = alignment;
    }

    this.syncContent();
  }

  insertButtonPlaceholder(): void {
    this.focusEditor();

    const tokenHtml = `
      <div
        class="fb-button-token"
        data-fb-type="button"
        data-align="${this.templateData.buttonAlign}"
        contenteditable="false"
        style="
          text-align:${this.templateData.buttonAlign};
          margin:20px 0;
          padding:12px;
          border:1px dashed #b7bcc5;
          border-radius:6px;
          background:#f8f9fb;
          color:#555;
          font-family:Arial, Helvetica, sans-serif;
          font-size:14px;
        "
      >
        [ Button: ${this.escapeHtml(this.templateData.buttonText)} ]
      </div>
      <p><br></p>
    `;

    document.execCommand('insertHTML', false, tokenHtml);
    this.syncContent();
  }

  insertAppStoreButtonPlaceholder(): void {
    this.focusEditor();

    const tokenHtml = `
      <div
        class="fb-button-token"
        data-fb-type="button_for_store"
        contenteditable="false"
        style="
          margin:20px 0;
          padding:12px;
          border:1px dashed #b7bcc5;
          border-radius:6px;
          background:#f8f9fb;
          color:#555;
          font-family:Arial, Helvetica, sans-serif;
          font-size:14px;
        "
      >
        [ Button: Play Store | App Store ]
      </div>
      <p><br></p>
    `;

    document.execCommand('insertHTML', false, tokenHtml);
    this.syncContent();
  }


  insertCredentials(): void {
    this.focusEditor();

    const tokenHtml = `
      <div style="text-align:center; margin:0 0 20px;">
        <p style="margin:0 0 10px;">Username : <b>{{__username__}}</b></p>
        <p style="margin:0;">Password : <b>{{__password__}}</b></p>
      </div>
      <p><br></p>
    `;

    document.execCommand('insertHTML', false, tokenHtml);
    this.syncContent();
  }

  updateButtonPlaceholders(): void {
    if (!this.editor) return;

    const editorEl = this.editor.nativeElement as HTMLElement;
    const tokens = editorEl.querySelectorAll('.fb-button-token');

    tokens.forEach((token: any) => {
      const type = token.getAttribute('data-fb-type');

      if (type === 'button') {
        token.setAttribute('data-align', this.templateData.buttonAlign);
        token.style.textAlign = this.templateData.buttonAlign;
        token.innerText = `[ Button: ${this.templateData.buttonText} ]`;
      }

      if (type === 'button_for_store') {
        token.innerText = `[ Button: Play Store | App Store ]`;
      }
    });

    this.syncContent();
  }

  syncContent(): void {
    if (!this.editor?.nativeElement) return;
    this.templateData.content = this.editor.nativeElement.innerHTML;
    this.generatePreview();
  }

  generatePreview(): void {
    const bodyHtml = this.buildEmailHtml();

    this.insertBtnFlag = !bodyHtml.includes(
      '<a href="https://example.com/demo-cta" target="_blank"'
    );

    const previewDoc = `
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <style>
            html, body {
              margin: 0;
              padding: 0;
              background: #f7f5fa;
            }

            table {
              border-collapse: collapse;
            }

            a {
              text-decoration: none;
            }
          </style>
        </head>
        <body>
          ${bodyHtml}
        </body>
      </html>
    `;

    this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(previewDoc);
  }

  buildEmailHtml(): string {
    const content = this.normalizeContentForEmail(this.templateData.content);

    return `
      <table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#f7f5fa" style="background-color:#f7f5fa;">
        <tr>
          <td align="center">
            <table width="600" cellpadding="0" cellspacing="0" border="0" style="width:600px;max-width:600px;">
              <tr>
                <td align="center" style="background:linear-gradient(to right,#e0e9e7,#b9bbb9,#b9bbb9);padding:40px 0;">
                  <img
                    src="https://s3.eu-west-2.amazonaws.com/restaurant.foodbud.app/menu_img/email_img/foodbud_icon.png"
                    alt="Foodbud"
                    width="100"
                    style="display:block;margin:auto;"
                  />
                </td>
              </tr>

              <tr>
                <td bgcolor="#ffffff" style="padding:30px;font-family:Helvetica,Arial,sans-serif;font-size:16px;color:#111111;line-height:24px;">
                  <!-- FB_CONTENT_START -->
                  ${content}
                  <!-- FB_CONTENT_END -->

                  <p style="margin:0 0 5px;">Warm regards,</p>
                  <p style="margin:0 0 20px;">The Foodbud Team</p>

                  <img
                    src="https://s3.eu-west-2.amazonaws.com/restaurant.foodbud.app/menu_img/email_img/foodbud.png"
                    alt="Foodbud Logo"
                    width="80"
                    style="display:block;"
                  />
                </td>
              </tr>

              <tr>
                <td align="center" style="padding:20px;font-size:10px;color:#666666;font-family:Helvetica,Arial,sans-serif;">
                  <p style="margin:0;">©2026 Foodbud Ltd. All Rights Reserved</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    `;
  }

  exportTemplate(): any {
    this.syncContent();

    const htmlForSave = this.buildEmailHtml().replace(
      /https:\/\/example\.com\/demo-cta/g,
      '{{cta_url}}'
    );

    return {
      id: this.template_id ?? null,
      template_name: this.emailData?.template_name ?? 'Default Template',
      subject: this.templateData.subject,
      html_content: htmlForSave,
      button_settings: JSON.stringify({
        text: this.templateData.buttonText,
        align: this.templateData.buttonAlign,
        bg_color: this.templateData.buttonBgColor,
        text_color: this.templateData.buttonTextColor,
        border_color: this.templateData.buttonBorderColor,
        border_radius: this.templateData.buttonBorderRadius,
        padding_y: this.templateData.buttonPaddingY,
        padding_x: this.templateData.buttonPaddingX,
        btn_cta: this.templateData.buttonCTA
      }),
      is_qr_attached: this.attachQRCode ? 1 : 0
    };
  }

  saveTemplate(): void {
    const payload = this.exportTemplate();

    this.httpSv.saveTemplate(payload).subscribe({
      next: (response: any) => {
        if (response?.status) {
          this.toastr.success('Template saved successfully', '', { timeOut: 2000 });
          this.onSubmit.emit();
        } else {
          this.toastr.error(response?.message || 'Failed to save template', '', {
            timeOut: 2000
          });
        }
      },
      error: (error: any) => {
        let errorMessage = 'Something went wrong';

        if (error?.error?.message) {
          errorMessage =
            typeof error.error.message === 'string'
              ? error.error.message
              : Object.values(error.error.message).join(', ');
        }

        this.toastr.error(errorMessage, '', { timeOut: 2000 });
      }
    });
  }

  private focusEditor(): void {
    if (this.editor?.nativeElement) {
      this.editor.nativeElement.focus();
    }
  }

  private findEditableBlock(node: HTMLElement | null): HTMLElement | null {
    const root = this.editor?.nativeElement as HTMLElement;
    const blockTags = ['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI'];

    while (node && node !== root) {
      if (blockTags.includes(node.tagName)) {
        return node;
      }
      node = node.parentElement;
    }

    return null;
  }

  private parseButtonSettings(settings: any): any {
    if (!settings) return {};

    if (typeof settings === 'string') {
      try {
        return JSON.parse(settings);
      } catch {
        return {};
      }
    }

    return settings;
  }

  private renderEmailButton(align: 'left' | 'center' | 'right' | string): string {
    const buttonAlign = (align || this.templateData.buttonAlign || 'center').toLowerCase();

    let outerAlign = 'center';
    if (buttonAlign === 'left') outerAlign = 'left';
    if (buttonAlign === 'right') outerAlign = 'right';

    return `
      <table
        data-fb-role="email-button"
        data-align="${outerAlign}"
        data-text="${this.escapeHtml(this.templateData.buttonText || 'Button')}"
        role="presentation"
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        style="margin:20px 0;"
      >
        <tr>
          <td align="${outerAlign}">
            <table role="presentation" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td
                  align="center"
                  bgcolor="${this.templateData.buttonBgColor}"
                  style="
                    background-color:${this.templateData.buttonBgColor};
                    border-radius:${this.templateData.buttonBorderRadius}px;
                  "
                >
                  <a
                    href="https://example.com/demo-cta"
                    target="_blank"
                    style="
                      display:block;
                      background-color:${this.templateData.buttonBgColor};
                      border:1px solid ${this.templateData.buttonBorderColor};
                      border-radius:${this.templateData.buttonBorderRadius}px;
                      padding:${this.templateData.buttonPaddingY}px ${this.templateData.buttonPaddingX}px;
                      font-family:Helvetica,Arial,sans-serif;
                      font-size:16px;
                      line-height:16px;
                      font-weight:bold;
                      color:${this.templateData.buttonTextColor} !important;
                      text-decoration:none !important;
                      white-space:nowrap;

                    "
                  >
                    ${this.templateData.buttonText}
                  </a>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    `;
  }

  private renderStoreButtons(): string {
    return `
      <table
        data-fb-role="store-buttons"
        role="presentation"
        border="0"
        cellspacing="0"
        cellpadding="0"
        align="center"
        style="margin:20px auto 0;"
      >
        <tr>
          <td style="padding-right:8px;">
            <a href="https://play.google.com/store/apps/details?id=com.cms.foodbudapp" target="_blank">
              <img
                src="https://s3.eu-west-2.amazonaws.com/restaurant.foodbud.app/menu_img/email_img/play_store.avif"
                alt="Get it on Google Play"
                style="display:block;height:50px;border:0;"
              />
            </a>
          </td>
          <td style="padding-left:8px;">
            <a href="https://apps.apple.com/in/app/foodbud/id1584641741" target="_blank">
              <img
                src="https://s3.eu-west-2.amazonaws.com/restaurant.foodbud.app/menu_img/email_img/app_store.avif"
                alt="Download on the App Store"
                style="display:block;height:50px;border:0;"
              />
            </a>
          </td>
        </tr>
      </table>
    `;
  }

  private escapeHtml(value: string): string {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  private normalizeContentForEmail(rawHtml: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawHtml || '';

    const buttonTokens = tempDiv.querySelectorAll('[data-fb-type="button"]');
    buttonTokens.forEach((token: any) => {
      const align = token.getAttribute('data-align') || this.templateData.buttonAlign;
      const wrapper = document.createElement('div');
      wrapper.innerHTML = this.renderEmailButton(align);
      token.replaceWith(wrapper.firstElementChild as Node);
    });

    const storeTokens = tempDiv.querySelectorAll('[data-fb-type="button_for_store"]');
    storeTokens.forEach((token: any) => {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = this.renderStoreButtons();
      token.replaceWith(wrapper.firstElementChild as Node);
    });

    const root = document.createElement('div');
    const childNodes = Array.from(tempDiv.childNodes);

    childNodes.forEach((node: any) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = (node.textContent || '').trim();
        if (text) {
          const p = document.createElement('p');
          p.style.margin = '0 0 20px';
          p.textContent = text;
          root.appendChild(p);
        }
        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return;

      const el = node as HTMLElement;

      if (el.tagName === 'TABLE') {
        root.appendChild(el.cloneNode(true));
        return;
      }

      const allowed = ['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI'];
      if (!allowed.includes(el.tagName)) {
        const p = document.createElement('p');
        p.style.margin = '0 0 20px';
        p.innerHTML = el.innerHTML;
        root.appendChild(p);
        return;
      }

      const clean = el.cloneNode(true) as HTMLElement;

      if (!clean.style.margin) {
        clean.style.margin = '0 0 20px';
      }

      if (el.style.textAlign) {
        clean.style.textAlign = el.style.textAlign;
      }

      root.appendChild(clean);
    });

    return root.innerHTML;
  }

  private extractEditableContent(fullHtml: string): string {
    if (!fullHtml) return '';

    const markerMatch = fullHtml.match(
      /<!--\s*FB_CONTENT_START\s*-->([\s\S]*?)<!--\s*FB_CONTENT_END\s*-->/i
    );

    let editableHtml = markerMatch?.[1]?.trim() || '';

    if (!editableHtml) {
      editableHtml = this.extractEditableContentFallback(fullHtml);
    }

    const doc = new DOMParser().parseFromString(
      `<div id="fb-editor-root">${editableHtml}</div>`,
      'text/html'
    );

    const root = doc.getElementById('fb-editor-root');
    if (!root) return editableHtml;

    this.replaceRenderedButtonsWithPlaceholders(root);

    return root.innerHTML.trim();
  }

  private extractEditableContentFallback(fullHtml: string): string {
    const doc = new DOMParser().parseFromString(fullHtml, 'text/html');

    const contentTd = Array.from(doc.querySelectorAll('td')).find((td) => {
      const bg = (td.getAttribute('bgcolor') || '').toLowerCase();
      return bg === '#ffffff' && !!td.querySelector('img[alt="Foodbud Logo"]');
    });

    if (!contentTd) return fullHtml;

    const clone = contentTd.cloneNode(true) as HTMLElement;

    const logo = clone.querySelector('img[alt="Foodbud Logo"]');
    if (logo) logo.remove();

    Array.from(clone.querySelectorAll('p')).forEach((p) => {
      const text = (p.textContent || '').trim();
      if (text === 'Warm regards,' || text === 'The Foodbud Team') {
        p.remove();
      }
    });

    return clone.innerHTML.trim();
  }

  private replaceRenderedButtonsWithPlaceholders(root: HTMLElement): void {
    const buttonTables = Array.from(root.querySelectorAll('[data-fb-role="email-button"]'));

    buttonTables.forEach((table) => {
      const align = (
        table.getAttribute('data-align') ||
        this.templateData.buttonAlign ||
        'center'
      ).toLowerCase();

      const text =
        table.getAttribute('data-text') ||
        table.querySelector('a')?.textContent?.trim() ||
        this.templateData.buttonText ||
        'Button';

      this.replaceNodeWithHtml(root, table, this.createButtonPlaceholderHtml(text, align));
    });

    const storeButtons = Array.from(root.querySelectorAll('[data-fb-role="store-buttons"]'));

    storeButtons.forEach((table) => {
      this.replaceNodeWithHtml(root, table, this.createStoreButtonPlaceholderHtml());
    });
  }

  private replaceNodeWithHtml(root: HTMLElement, node: Element, html: string): void {
    const temp = root.ownerDocument.createElement('div');
    temp.innerHTML = html.trim();
    node.replaceWith(...Array.from(temp.childNodes));
  }

  private createButtonPlaceholderHtml(text: string, align: string): string {
    return `
      <div
        class="fb-button-token"
        data-fb-type="button"
        data-align="${align}"
        contenteditable="false"
        style="
          text-align:${align};
          margin:20px 0;
          padding:12px;
          border:1px dashed #b7bcc5;
          border-radius:6px;
          background:#f8f9fb;
          color:#555;
          font-family:Arial, Helvetica, sans-serif;
          font-size:14px;
        "
      >
        [ Button: ${this.escapeHtml(text)} ]
      </div>
      <p><br></p>
    `;
  }

  private createStoreButtonPlaceholderHtml(): string {
    return `
      <div
        class="fb-button-token"
        data-fb-type="button_for_store"
        contenteditable="false"
        style="
          margin:20px 0;
          padding:12px;
          border:1px dashed #b7bcc5;
          border-radius:6px;
          background:#f8f9fb;
          color:#555;
          font-family:Arial, Helvetica, sans-serif;
          font-size:14px;
        "
      >
        [ Button: Play Store | App Store ]
      </div>
      <p><br></p>
    `;
  }
}